import { render, staticRenderFns } from "./AccountCredentials.vue?vue&type=template&id=06fb9217&scoped=true"
import script from "./AccountCredentials.vue?vue&type=script&lang=js"
export * from "./AccountCredentials.vue?vue&type=script&lang=js"
import style0 from "./AccountCredentials.vue?vue&type=style&index=0&id=06fb9217&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fb9217",
  null
  
)

export default component.exports